class FaqSearch {
  constructor() {
    this.component = $('.faq-search');
    this.accordeons = $('.accordeon-wrap');
    this.search = $('.form-control', this.component);

    this.lists = [];
  }
  
  init() {
    this.setList();
    this.updateHandler();
  }

  /**
   * Initiate the List library
   */
  setList() {
    this.accordeons.each((idx, element) => {
      element.addEventListener('listjs.created', e => this.handleListCreatedEvent(e));
    });
  }

  handleListCreatedEvent(e) {
    this.lists.push(e.detail);
  }

  /**
   * Run functions when the List object gets updated
   */
  updateHandler() {
    this.search.on('keyup', () => {
      for (let x = 0; x < this.lists.length; x += 1) {
        this.lists[x].search(this.search.val());
      }
    });
  }
}

$(document).ready(() => {
  new FaqSearch().init();
});
